import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.1.0/js/sparta-transport-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.7/js/sparta-ui-layers-utility";
/**
 * sparta-global-utility
 *
 * Copyright (c) 2016-08-08 Justin Johnson
 */


class spartaGlobalUtility {


  constructor(){
    this.spartaStore = spartaStoreUtility;
    this.spartaEvent = spartaEventsUtility;
    this.spartaTransport = spartaTransportUtility;
    this.spartaUtils = spartaGlobalUtility;
  }

}


export default spartaGlobalUtility;
